import { Link } from "@mui/material";
import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

const PredatorsLink = () => (
  <Link
    target="_blank"
    sx={{
      fontWeight: 500,
      color: "primary.main",
      textDecoration: "none",
    }}
    href="https://am.ticketmaster.com/predators/"
  >
    Account Manager
  </Link>
);

export const purchaseSeatsLanguages = {
  similarSeatModalBody: (seatTitle: string) => {
    return <>We are going to find similar seats for all games in your pack</>;
  },
  progressBarText:
    "Select 3 games for 10% off your tickets, or 4+ games for an additional 5% off those seats!",
  progressBarAditionalText: " for 10% off your tickets!",
};

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Games",
    description: "Select the games you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager",
    description: (
      <>
        Click Continue and connect your Nashville Predators <PredatorsLink />{" "}
        using our secure Ticketmaster login.
      </>
    ),
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each game.",
  },

  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager within 24 hours of redemption. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Nashville 3 Game Flex work?",
    description:
      "The Nashville Predators 3 Game Flex program allows fans to select a minimum of 3 games for 10% off, or 4+ games for 15% off! Included in this offer is a $10 Gnash Cash per seat, a $30 Hattie B's Gift Card, presale opportunities for 2025 Stanley Cup Playoff, and access to 25-26 Season Ticket Plans before the general public (with deposit). Simply log into your Nashville Predators Account Manager and select games.",
  },
  {
    title: "Do I have to select all my games now?",
    description:
      "To be eligible for the promotion, you must select all games at the same time.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description:
      "After you select games, you will be prompted to select from available inventory for those seats.",
  },
  {
    title: "Where are tickets delivered?",
    description: (
      <>
        Event tickets are delivered directly within your Nashville Predators
        <PredatorsLink />.
      </>
    ),
  },
];
